module.exports = __webpack_public_path__ + "img/18.25a27f03.jpg";